import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = ["href", "textContent"]

import { computed, Ref, ref, toRef } from 'vue';
import Chip from 'primevue/chip';
import AddPersonModal from '@/components/AddPersonModal/AddPersonModal.vue';
import { useToast } from 'primevue/usetoast';
import { useGuardianStore } from '@/store';
import { GuardianInterface } from '@/types';
import { EMIT, PERMISSIONS } from '@/enum';
import { can } from '@/composables';

interface GuardianPropsInterface {
  tableData?: GuardianInterface[];
  studentId?: number;
  loading?: boolean;
}

interface GuardianTableInterface {
  id: number;
  display_name: string;
  relationship?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GuardianTable',
  props: {
    tableData: {},
    studentId: {},
    loading: { type: Boolean }
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const guardianStore = useGuardianStore();
const guardians: Ref<GuardianInterface[] | undefined> = toRef(props, 'tableData');
const guardianCount: Ref<number> = computed(() => (guardians.value ? guardians.value.length : 0));
const guardianModalOpen = ref(false);
const toast = useToast();
const guardianItems: Ref<{ name: string; value: number }[]> = ref([]);

const createMenuModel = (item: GuardianTableInterface) => {
  const menuItem = {
    label: 'Remove Guardian',
    command: () => {
      detachGuardian([item.id], item.display_name);
    },
    visible: can([PERMISSIONS.STUDENT_DETACH_CLINICIANS]),
  };
  return [menuItem].filter((item) => item.visible);
};

const attachGuardian: (ids: number[]) => Promise<void> = async (ids) => {
  await guardianStore.attachGuardians({ parents: ids, studentId: props.studentId as number });
  emit(EMIT.UPDATE);
  toast.add({
    severity: 'success',
    summary: 'Added',
    detail: 'Guardian(s) has been added',
    life: 3000,
  });
};

const detachGuardian: (ids: number[], guardianName: string) => Promise<void> = async (ids, guardianName) => {
  await guardianStore.detachGuardians({ parents: ids, studentId: props.studentId as number });
  emit(EMIT.UPDATE);
  toast.add({
    severity: 'success',
    summary: 'Removed',
    detail: `Guardian ${guardianName} has been removed from student`,
    life: 3000,
  });
};

const openAddGuardians = async () => {
  if (can([PERMISSIONS.STUDENT_CLINICIANS_AVAILABLE_TO_ADD]) && can([PERMISSIONS.STUDENT_ATTACH_CLINICIANS])) {
    guardianItems.value = await guardianStore.getAddGuardiansModalData(props.studentId as number);
    guardianModalOpen.value = true;
  } else {
    toast.add({
      severity: 'warning',
      summary: 'Error',
      detail: 'You do not have permission to add guardians',
      life: 3000,
    });
  }
};

const onCancelAdd = () => (guardianModalOpen.value = false);

const onSaveAdd = (guardians: { name: string; value: number }[]) => {
  let guardianIds = guardians.map((guardian) => guardian.value);
  attachGuardian(guardianIds);
  guardianModalOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Guardians", -1)),
      _createVNode(_unref(Chip), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(guardianCount.value), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).STUDENT_ATTACH_CLINICIANS]))
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              type: "text",
              size: "small",
              text: "Add Guardians",
              "icon-left": "add",
              onClick: openAddGuardians
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: guardians.value,
        "global-filter-fields": ['name'],
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: __props.loading,
        "data-key": "name",
        "responsive-layout": "scroll",
        "scroll-height": "440px",
        "state-key": "session-store-guardians-table",
        "state-storage": "session",
        class: _normalizeClass({ 'table-loading': __props.loading })
      }, {
        empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Guardians not assigned", -1)
        ]))]),
        default: _withCtx(() => [
          (guardianCount.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_Column, {
                  "body-class": "mw-20rem",
                  "header-class": "mw-20rem",
                  field: "display_name",
                  header: "Guardian Name",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("a", {
                      class: "item-link font-semibold",
                      href: `/user/${data.id}`,
                      textContent: _toDisplayString(data.display_name)
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "relationship",
                  header: "Relationship"
                }),
                _createVNode(_component_Column, {
                  "body-class": "justify-content-center mw-10rem",
                  "header-class": "justify-content-center mw-10rem",
                  field: "id",
                  header: "Actions"
                }, {
                  body: _withCtx(({ data }) => [
                    (createMenuModel(data).length > 0)
                      ? (_openBlock(), _createBlock(_component_ActionMenu, {
                          key: 0,
                          "menu-items": createMenuModel(data),
                          icon: "more_horiz"
                        }, null, 8, ["menu-items"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading", "class"]),
      (guardianModalOpen.value && _unref(can)([_unref(PERMISSIONS).STUDENT_CLINICIANS_AVAILABLE_TO_ADD]))
        ? (_openBlock(), _createBlock(AddPersonModal, {
            key: 0,
            title: "Add Guardians",
            "button-text": "Add Guardians",
            items: guardianItems.value,
            searchable: true,
            onAddItems: onSaveAdd,
            onCancel: onCancelAdd
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})